export const environment = {
    api_url: "https://api.fantasyescapegames.com",
    app_url: "https://app.fantasyescapegames.com"
};